import { MESSAGE_CONTENT_TYPE, MESSAGE_TYPE } from "@home-health-notify/domain";
import React from "react";
import { UserTitle } from "../../common/user/UserText";
import { IMessageContentTypeBubble } from "../MessagePanel";
import {
  MessageContentTypeWrapper,
  MessageContentWrapper,
  MessageTitle,
} from "./MessageContentStyle";
import AudioContent from "./contentType/AudioContent";
import DocumentContent from "./contentType/DocumentContent";
import FallbackContent from "./contentType/FallbackContent";
import { FormContent } from "./contentType/FormContent";
import ImageContent from "./contentType/ImageContent";
import LocationContent from "./contentType/LocationContent";
import ReminderContent from "./contentType/ReminderContent";
import TextContent from "./contentType/TextContent";
import VideoContent from "./contentType/VideoContent";
import { SmartContent } from "./contentType/smartContent/SmartContent";
import LinkContent from "./contentType/LinkContent";

const MessageContentType = ({
  message,
  isSender,
  openMediaDialog,
  chatInfoAccess,
  forcedFallbackContent = false,
  disableActions = false,
}: IMessageContentTypeBubble) => {
  type IMessageTypeComponentMap = {
    [key in MESSAGE_CONTENT_TYPE]: React.ElementType;
  };
  const messageData = message.getMessage();
  const messageType = messageData.type;
  const contentType = messageData.contentType;
  const MessageTypeComponentMap: IMessageTypeComponentMap = {
    [MESSAGE_CONTENT_TYPE.DOCUMENT]: DocumentContent,
    [MESSAGE_CONTENT_TYPE.IMAGE]: ImageContent,
    [MESSAGE_CONTENT_TYPE.LINK]: LinkContent,
    [MESSAGE_CONTENT_TYPE.LOCATION]: LocationContent,
    [MESSAGE_CONTENT_TYPE.REMINDER]: ReminderContent,
    [MESSAGE_CONTENT_TYPE.VIDEO]: VideoContent,
    [MESSAGE_CONTENT_TYPE.TEXT]: TextContent,
    [MESSAGE_CONTENT_TYPE.VOICE]: AudioContent,
    [MESSAGE_CONTENT_TYPE.FORM]: FormContent,
    [MESSAGE_CONTENT_TYPE.SMART]: SmartContent,
  };
  const isMessageTypeInfo = messageType === MESSAGE_TYPE.INFO;
  const MessageContentTypeComponent = forcedFallbackContent
    ? FallbackContent
    : MessageTypeComponentMap[contentType] || FallbackContent;
  const canShowTitle = !isSender && !isMessageTypeInfo;
  return (
    <MessageContentTypeWrapper>
      {canShowTitle && (
        <MessageTitle>
          <UserTitle userId={messageData.from} />
        </MessageTitle>
      )}
      <MessageContentWrapper disableActions={disableActions}>
        <MessageContentTypeComponent
          message={message}
          isSender={isSender}
          openMediaDialog={openMediaDialog}
          chatInfoAccess={chatInfoAccess}
        />
      </MessageContentWrapper>
    </MessageContentTypeWrapper>
  );
};

export default MessageContentType;
